import { render, staticRenderFns } from "./Treatments_Frequency.vue?vue&type=template&id=4c77b8aa"
import script from "./Treatments_Frequency.vue?vue&type=script&lang=js"
export * from "./Treatments_Frequency.vue?vue&type=script&lang=js"
import style0 from "./Treatments_Frequency.vue?vue&type=style&index=0&id=4c77b8aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports